var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5748 9.54822C2.1916 8.35433 1 7.75738 1 7.01458C1 6.27178 2.1916 5.67634 4.5748 4.48094L7.9444 2.79234C10.3276 1.59695 11.5204 1 13 1C14.4796 1 15.6724 1.59695 18.0556 2.79234L21.4252 4.48094C23.8084 5.67483 25 6.27178 25 7.01458C25 7.75738 23.8084 8.35283 21.4252 9.54822L18.0556 11.2383C15.6724 12.4322 14.4796 13.0292 13 13.0292C11.5204 13.0292 10.3276 12.4322 7.9444 11.2383L4.5748 9.54822Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5192 10.0219L4.5748 10.4955C2.1916 11.6894 1 12.2878 1 13.0291C1 13.7704 2.1916 14.3674 4.5748 15.5628L7.9444 17.2529C10.3276 18.4468 11.5204 19.0437 13 19.0437C14.4796 19.0437 15.6724 18.4468 18.0556 17.2529L21.4252 15.5628C23.8084 14.3689 25 13.7704 25 13.0291C25 12.2878 23.8084 11.6909 21.4252 10.4955L20.4808 10.0219",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5192 16.0365L4.5748 16.5101C2.1916 17.704 1 18.3025 1 19.0438C1 19.7851 2.1916 20.382 4.5748 21.5774L7.9444 23.2675C10.3276 24.4614 11.5204 25.0584 13 25.0584C14.4796 25.0584 15.6724 24.4614 18.0556 23.266L21.4252 21.5774C23.8084 20.3835 25 19.7866 25 19.0438C25 18.3025 23.8084 17.7055 21.4252 16.5101L20.4808 16.0365",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.56438f8c14293a45f5d73cde3bfbb70a.svg";
export { ForwardRef as ReactComponent };